import { http } from "../api/http";

// KB Runbook Builder — same host/auth/request/response shape as aiBuilder.service,
// but points at the knowledge-base builder route and carries a server-owned
// conversationId. Runs side-by-side with the classic builder.
export const kbBuilderService = {
  generate,
  reportIssue,
};

async function generate(payload) {
  const response = await http.post("/ai-builder/kb-generate", JSON.stringify(payload));
  return response.data;
}

// Report an issue: bundle the conversation (transcript, decisions, metadata) + current canvas
// runbook into a zip. Returns { fileName, contentType, contentBase64 } for the caller to download.
async function reportIssue(payload) {
  const response = await http.post("/ai-builder/report-issue", JSON.stringify(payload));
  return response.data;
}
